
export enum GoogleLocationType {
  STREET_NUMBER = 'street_number',
  POSTAL_CODE = 'postal_code',
  PROVINCE = 'administrative_area_level_2',
  AC = 'administrative_area_level_1',
  LOCALITY = 'locality',
  STREET_ADDRESS = 'street_address',
  COUNTRY = 'country',
  ROUTE = 'route'
}

export enum GoogleMapsCoords {
  COORDS_X = 40.416667,
  COORDS_Y = -3.703889
}

export const RequiredGoogleLocationTypes = [GoogleLocationType.POSTAL_CODE, GoogleLocationType.LOCALITY, GoogleLocationType.COUNTRY];

export enum GoogleMapsResponseStatus {
  OK = 'OK',
  ZERO_RESULTS = 'ZERO_RESULTS'
}

export interface GoogleMapsResponse {
  plus_code?: PlusCode;
  results?: GoogleMapResult[];
  status: GoogleMapsResponseStatus;
}

export interface GoogleMapResult {
  address_components?: GoogleAddressComponent[];
  formatted_address?: string;
  geometry?: ComponentGeometry;
  place_id?: string;
  types?: string;
  plus_code?: PlusCode;
}

export interface GoogleAddressComponent {
  long_name?: string;
  short_name?: string;
  types?: string[];
}

interface ComponentGeometry {
  location: LatLng;
  location_type?: string;
}

export interface LatLng {
  lat: number;
  lng: number;
}

interface PlusCode {
  compound_code?: string;
  global_code?: string;
}


